// 新店推广

export default [
    {
        path: '/newHotelPromotion',
        name: 'newHotelPromotion',
        component: () => import(/* webpackChunkName:"newHotelPromotion"*/'@/pages/newHotelPromotion/index.vue'),
        meta: {
            title: '新店开业',
        },
    },
    {
        path: '/time',
        name: 'time',
        component: () => import(/* webpackChunkName:"newHotelPromotion"*/'@/pages/newHotelPromotion/time.vue'),
        meta: {
            title: '入店离店',
        },
    },
    {
        path: '/city',
        name: 'city',
        component: () => import(/* webpackChunkName:"newHotelPromotion"*/'@/pages/newHotelPromotion/city.vue'),
        meta: {
            title: '选择城市',
        },
    },
];
